import { render, staticRenderFns } from "./Jkxkz.vue?vue&type=template&id=42b90c71&scoped=true&"
import script from "./Jkxkz.vue?vue&type=script&lang=js&"
export * from "./Jkxkz.vue?vue&type=script&lang=js&"
import style0 from "./Jkxkz.vue?vue&type=style&index=0&id=42b90c71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b90c71",
  null
  
)

export default component.exports